import { render, staticRenderFns } from "./userDashboardNutritionWeightChart.vue?vue&type=template&id=0e353694&scoped=true"
import script from "./userDashboardNutritionWeightChart.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionWeightChart.vue?vue&type=script&lang=js"
import style0 from "./userDashboardNutritionWeightChart.vue?vue&type=style&index=0&id=0e353694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e353694",
  null
  
)

export default component.exports